import api from './api.service';

function unwrap<T>(res: unknown): T {
  const d = (res as { data?: { data?: unknown } })?.data?.data ?? (res as { data?: unknown })?.data ?? res;
  return d as T;
}

export type SalesConversionReportFilters = {
  date_from?: string;
  date_to?: string;
  funnel_mode?: 'volume' | 'cohort';
  compare_to?: 'prior_period' | 'prior_year' | '';
  customer_id?: string;
  sales_team_id?: string;
  revenue_service_type_id?: string;
  industry?: string;
};

class SalesConversionReportsService {
  private base = '/sales/reports';

  private get<T>(path: string, filters?: SalesConversionReportFilters) {
    const params: Record<string, string> = {};
    if (filters) {
      for (const [k, v] of Object.entries(filters)) {
        if (v != null && String(v).trim() !== '') params[k] = String(v);
      }
    }
    return api.get(`${this.base}${path}`, { params }).then((res) => unwrap<T>(res));
  }

  conversionFunnel(filters?: SalesConversionReportFilters) {
    return this.get<Record<string, unknown>>('/conversion-funnel', filters);
  }

  quotationConversionAnalytics(filters?: SalesConversionReportFilters) {
    return this.get<Record<string, unknown>>('/quotation-conversion-analytics', filters);
  }

  opportunityConversion(filters?: SalesConversionReportFilters) {
    return this.get<Record<string, unknown>>('/opportunity-conversion', filters);
  }

  winLoss(filters?: SalesConversionReportFilters) {
    return this.get<Record<string, unknown>>('/win-loss', filters);
  }

  salespersonPerformance(filters?: SalesConversionReportFilters) {
    return this.get<{ rows: Record<string, unknown>[] }>('/salesperson-performance', filters);
  }

  productRstMix(filters?: SalesConversionReportFilters) {
    return this.get<Record<string, unknown>>('/product-rst-mix', filters);
  }

  bookingBillingCollections(filters?: SalesConversionReportFilters) {
    return this.get<Record<string, unknown>>('/booking-billing-collections', filters);
  }
}

export const salesConversionReportsService = new SalesConversionReportsService();
export default salesConversionReportsService;
